import { render, staticRenderFns } from "./crupier.vue?vue&type=template&id=2fc3bb6e&scoped=true&"
import script from "./crupier.vue?vue&type=script&lang=js&"
export * from "./crupier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3bb6e",
  null
  
)

export default component.exports